"use client";

import Link from "next/link";
import { useState } from "react";
import { PRICING_META, formatPeso } from "@/lib/content";
import { AddToCartButton } from "./AddToCartButton";

type PricingModule = {
  id: string;
  name: string;
  category: "suite";
  role?: "floor" | "mid" | "ceiling";
  monthlyList: number;
  status: "available" | "coming-soon";
  tagline: string;
  capabilities: readonly string[];
  service: string;
};

export function PricingModuleCard({ module: mod }: { module: PricingModule }) {
  const [open, setOpen] = useState(false);
  const preview = mod.capabilities.slice(0, PRICING_META.capabilityPreview);
  const rest = mod.capabilities.slice(PRICING_META.capabilityPreview);
  const available = mod.status === "available";

  return (
    <article
      className={`pricing-module-card pricing-module-card--${mod.category}${mod.role ? ` pricing-module-card--${mod.role}` : ""}${!available ? " is-soon" : ""}`}
    >
      <div className="pricing-module-accent" aria-hidden />
      <div className="pricing-module-head">
        <div className="pricing-module-badges">
          <span className="service-tag">JD Apps</span>
          <span
            className={`pricing-status-chip${available ? " is-available" : " is-soon"}`}
          >
            {available ? "Available" : "Coming soon"}
          </span>
        </div>
        <h3>{mod.name}</h3>
        <p className="pricing-module-tagline">{mod.tagline}</p>
        <p className="pricing-module-price">
          <span className="pricing-module-amount">
            {formatPeso(mod.monthlyList)}
          </span>
          <span className="pricing-module-period">/ org / month</span>
        </p>
      </div>
      <ul className="pricing-module-caps">
        {preview.map((item) => (
          <li key={item}>{item}</li>
        ))}
        {open && rest.map((item) => (
          <li key={`${mod.id}-${item}`}>{item}</li>
        ))}
      </ul>
      {rest.length > 0 ? (
        <button
          type="button"
          className="pricing-module-details-btn linkish"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Hide details" : "See details"}
        </button>
      ) : null}
      {available ? (
        <AddToCartButton moduleId={mod.id} />
      ) : (
        <Link
          href={`/contact?intent=quote&service=${encodeURIComponent(`${mod.service} (waitlist)`)}`}
          className="btn btn-ghost"
        >
          Join waitlist
        </Link>
      )}
    </article>
  );
}
